import Vue from 'vue';
import Router from 'vue-router';
import { store } from './store.js';
import axios from 'axios';
import VueCookie from 'vue-cookie';

import Index from '../src/components/Index/Index.vue';
import Login from '../src/components/Index/Login.vue';
import AccountRegister from '../src/components/Index/AccountRegister.vue';
import EmailConfirm from '../src/components/Index/EmailConfirm.vue';
import ResendEmail from '../src/components/Index/ResendEmail.vue';
import PasswordReset from '../src/components/Index/PasswordReset.vue';
import PasswordResetCode from '../src/components/Index/PasswordResetCode.vue';
import SupportTickets from '../src/components/Index/SupportTickets.vue';
import ViewTickets from '../src/components/Index/ViewTickets.vue';
import SupportTicketsReply from '../src/components/Index/SupportTicketsReply.vue';
import Support from '../src/components/Index/Support.vue';
import TermsOfService from '../src/components/Index/TermsOfService.vue';
import PrivacyPolicy from '../src/components/Index/PrivacyPolicy.vue';
import Help from '../src/components/Index/Help.vue';

import Home from '../src/components/Home/Index.vue';
import Settings from '../src/components/Home/Settings.vue';
import Withdrawal from '../src/components/Home/Withdrawal.vue';

import PTP from '../src/components/Home/PTP.vue';
import LoginHistory from '../src/components/Home/LoginHistory.vue';
import WithdrawalHistory from '../src/components/Home/WithdrawalHistory.vue';
import Referrals from '../src/components/Home/Referrals.vue';
import Account from '../src/components/Home/Account.vue';
import Banners from '../src/components/Home/Banners.vue';
import HomeSupport from '../src/components/Home/Support.vue';
import HomeViewTickets from '../src/components/Home/ViewTickets.vue';
import HomeSupportTickets from '../src/components/Home/SupportTickets.vue';
import HomeSupportTicketsReply from '../src/components/Home/SupportTicketsReply.vue';
import Advertise from '../src/components/Home/Advertise.vue';
import OrderHistory from '../src/components/Home/OrderHistory.vue';
import Deposit from '../src/components/Home/Deposit.vue';
import DepositHistory from '../src/components/Home/DepositHistory.vue';
import Offerwalls from '../src/components/Home/Offerwalls.vue';
import Rates from '../src/components/Home/Rates.vue';
import AdvertiserPanelPTP from '../src/components/Home/AdvertiserPanelPTP.vue';
import AdvertiserPanelBanner from '../src/components/Home/AdvertiserPanelBanner.vue';
import AdvertiserPanelSquareBanner from '../src/components/Home/AdvertiserPanelSquareBanner.vue';
import AdvertiserPanelBonusAds from '../src/components/Home/AdvertiserPanelBonusAds.vue';
import BonusAds from '../src/components/Home/BonusAds.vue';


import Hitswall from '../src/components/Offerwalls/Hitswall.vue';
import PTCWall from '../src/components/Offerwalls/PTCWall.vue';
import SkippyAds from '../src/components/Offerwalls/SkippyAds.vue';
import KiwiWall from '../src/components/Offerwalls/KiwiWall.vue';
import OfferToro from '../src/components/Offerwalls/OfferToro.vue';

Vue.use(Router);

function requireAuth(to, from, next) {

    axios.get(store.state.SessionValidApi, { params: { sessionId: VueCookie.get('sessionId') } })
        .then((response) => { next(); })
        .catch((error) => {
            VueCookie.set('lsi', VueCookie.get('sessionId'), { expires: '30D' });
            VueCookie.delete('sessionId');
            store.commit('authorizationChange', 0);
            store.commit('sessionValidState', false);
            store.commit('storeUserData', null);
            next('/');
        })

    //Below code is commented as it was required to verify user's logged in status before proceeding to App.vue code

    //switch (store.state.authorization) {
    //    case 0:  //0 == Somebody but not logged in
    //        next('/');
    //        break;
    //    case 1:  //1 == General user logged in
    //        next();
    //        break;
    //    default:
    //        next('/');
    //}

}

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
            path: '/AccountRegister',
            name: 'AccountRegister',
            component: AccountRegister
        },
        {
            path: '/EmailConfirm',
            name: 'EmailConfirm',
            component: EmailConfirm
        },
        {
            path: '/ResendEmail',
            name: 'ResendEmail',
            component: ResendEmail
        },
        {
            path: '/PasswordReset',
            name: 'PasswordReset',
            component: PasswordReset
        },
        {
            path: '/PasswordResetCode',
            name: 'PasswordResetCode',
            component: PasswordResetCode
        },
        {
            path: '/SupportTickets',
            name: 'SupportTickets',
            component: SupportTickets
        },
        {
            path: '/ViewTickets',
            name: 'ViewTickets',
            component: ViewTickets
        },
        {
            path: '/SupportTicketsReply',
            name: 'SupportTicketsReply',
            component: SupportTicketsReply
        },
        {
            path: '/Support',
            name: 'Support',
            component: Support
        },
        {
            path: '/TermsOfService',
            name: 'TermsOfService',
            component: TermsOfService
        },
        {
            path: '/PrivacyPolicy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/Help',
            name: 'Help',
            component: Help
        },
        //Routes from here require authentication of user logged in
        {
            path: '/Home',
            name: 'Home',
            component: Home,
            beforeEnter: requireAuth
        },
        {
            path: '/Settings',
            name: 'Settings',
            component: Settings,
            beforeEnter: requireAuth
        },
        {
            path: '/Withdrawal',
            name: 'Withdrawal',
            component: Withdrawal,
            beforeEnter: requireAuth
        },
        {
            path: '/HomeSupportTickets',
            name: 'HomeSupportTickets',
            component: HomeSupportTickets,
            beforeEnter: requireAuth
        },
        {
            path: '/HomeSupportTicketsReply',
            name: 'HomeSupportTicketsReply',
            component: HomeSupportTicketsReply,
            beforeEnter: requireAuth
        },
        {
            path: '/PTP',
            name: 'PTP',
            component: PTP,
            beforeEnter: requireAuth
        },
        {
            path: '/LoginHistory',
            name: 'LoginHistory',
            component: LoginHistory,
            beforeEnter: requireAuth
        },
        {
            path: '/WithdrawalHistory',
            name: 'WithdrawalHistory',
            component: WithdrawalHistory,
            beforeEnter: requireAuth
        },
        {
            path: '/Referrals',
            name: 'Referrals',
            component: Referrals,
            beforeEnter: requireAuth
        },
        {
            path: '/Account',
            name: 'Account',
            component: Account,
            beforeEnter: requireAuth
        },
        {
            path: '/Banners',
            name: 'Banners',
            component: Banners,
            beforeEnter: requireAuth
        },
        {
            path: '/HomeSupport',
            name: 'HomeSupport',
            component: HomeSupport,
            beforeEnter: requireAuth
        },
        {
            path: '/HomeViewTickets',
            name: 'HomeViewTickets',
            component: HomeViewTickets,
            beforeEnter: requireAuth
        },
        {
            path: '/Advertise',
            name: 'Advertise',
            component: Advertise,
            beforeEnter: requireAuth
        },
        {
            path: '/OrderHistory',
            name: 'OrderHistory',
            component: OrderHistory,
            beforeEnter: requireAuth
        },
        {
            path: '/Deposit',
            name: 'Deposit',
            component: Deposit,
            beforeEnter: requireAuth
        },
        {
            path: '/DepositHistory',
            name: 'DepositHistory',
            component: DepositHistory,
            beforeEnter: requireAuth
        },
        {
            path: '/Offerwalls',
            name: 'Offerwalls',
            component: Offerwalls,
            beforeEnter: requireAuth
        },
        {
            path: '/Hitswall',
            name: 'Hitswall',
            component: Hitswall,
            beforeEnter: requireAuth
        },
        {
            path: '/PTCWall',
            name: 'PTCWall',
            component: PTCWall,
            beforeEnter: requireAuth
        },
        {
            path: '/SkippyAds',
            name: 'SkippyAds',
            component: SkippyAds,
            beforeEnter: requireAuth
        },
        {
            path: '/KiwiWall',
            name: 'KiwiWall',
            component: KiwiWall,
            beforeEnter: requireAuth
        },
        {
            path: '/Rates',
            name: 'Rates',
            component: Rates,
            beforeEnter: requireAuth
        },
        {
            path: '/AdvertiserPanelPTP',
            name: 'AdvertiserPanelPTP',
            component: AdvertiserPanelPTP,
            beforeEnter: requireAuth
        },
        {
            path: '/AdvertiserPanelBanner',
            name: 'AdvertiserPanelBanner',
            component: AdvertiserPanelBanner,
            beforeEnter: requireAuth
        },
        {
            path: '/AdvertiserPanelSquareBanner',
            name: 'AdvertiserPanelSquareBanner',
            component: AdvertiserPanelSquareBanner,
            beforeEnter: requireAuth
        },
        {
            path: '/AdvertiserPanelBonusAds',
            name: 'AdvertiserPanelBonusAds',
            component: AdvertiserPanelBonusAds,
            beforeEnter: requireAuth
        },
        {
            path: '/BonusAds',
            name: 'BonusAds',
            component: BonusAds,
            beforeEnter: requireAuth
        },
        {
            path: '/OfferToro',
            name: 'OfferToro',
            component: OfferToro,
            beforeEnter: requireAuth
        }
    ]
})
